// src/components/dialog/DlgUserPicture.tsx

import { DeleteTwoTone, PublishTwoTone } from '@mui/icons-material'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  useTheme,
} from '@mui/material'
import { useEffect, useRef, useState } from 'react'

import { UserId } from '@/types/domain'
import { KARMA_BasicDialog } from '@/types/karma/dialog'

import avatar from '../../assets/img/default-avatar.png'
import { useUser } from '../../hooks'

type Props = KARMA_BasicDialog & {
  id: UserId
}

export const DlgUserPicture = ({ onClose, open, id }: Props) => {
  const userData2 = useUser(id)

  const theme = useTheme()
  const { white: color } = theme.palette

  const [userData, setUserData] = useState<{ image_url?: string | File }>({})
  const [imagePreviewUrl, setImagePreviewUrl] = useState(avatar)

  const CLEAR_DISABLED = !userData.image_url && userData.image_url === ''

  const ref = useRef<HTMLInputElement | null>(null)

  const onClear = () => {
    setImagePreviewUrl(avatar)
    setUserData(prev => ({ ...prev, image_url: avatar }))
    if (ref.current) ref.current.value = ''
  }
  const onClick = () => ref.current?.click()
  const onUpload = event => {
    const image_url = event.target.files[0]

    event.preventDefault()

    const reader = new FileReader()
    reader.readAsDataURL(image_url)
    reader.onloadend = () => {
      setUserData(prev => ({ ...prev, image_url }))
      setImagePreviewUrl(reader.result as string)
    }
  }

  useEffect(() => {
    if (!userData2) return
    const { image_url } = userData2

    setImagePreviewUrl(image_url || avatar)
  }, [userData2])

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Profilbild von {userData2?.firstname} {userData2?.lastname}
      </DialogTitle>

      <DialogContent>
        <Box alt={''} component={'img'} src={imagePreviewUrl} />
      </DialogContent>

      <DialogActions>
        <Tooltip title={'Hochladen'}>
          <Button onClick={onClick} sx={{ color }}>
            <PublishTwoTone sx={{ mr: 1 }} />
          </Button>
        </Tooltip>

        <input
          accept={'image/*'}
          hidden
          onChange={onUpload}
          ref={ref}
          type={'file'}
        />

        <Tooltip title={'Löschen'}>
          <Button disabled={CLEAR_DISABLED} onClick={onClear} sx={{ color }}>
            <DeleteTwoTone sx={{ mr: 1 }} /> Löschen
          </Button>
        </Tooltip>
      </DialogActions>
    </Dialog>
  )
}
